import { isEmptyValue } from '@/utils/common'
import { isEmpty } from 'lodash'

function fontChange(context) {
  var width = context.chart.width
  var size = width <= 700 ? 12 : 17
  return {
    size: size,
  }
}

const Glassonsfooter = (tooltipItems) => {
  let totalInspection = 0
  let totalOrder = 0

  tooltipItems.forEach(({ dataset: { label }, raw }) => {
    if (label === 'Total Order Inspected') totalInspection = raw
    if (label === 'Total Order Assign') totalOrder = raw
  })

  const percentage = (totalInspection / (totalInspection + totalOrder)) * 100
  return `Percentage of Order Inspected: ${
    percentage ? percentage.toFixed(2) : percentage
  } %`
}

function getLabels(labels: any, index: any) {
  if (isEmptyValue(labels)) {
    return index
  }
  const tmp = labels[index]
  const tmpArray = tmp?.split(' ')
  if (tmpArray?.length > 5) {
    return `${tmpArray[0]} ${tmpArray[1]} ${tmpArray[2]} ${tmpArray[3]} ${tmpArray[4]} .....`
  }
  return tmp ?? 'NULL'
}

function getLabelsMultiArray(labels: any, index: any) {
  if (isEmptyValue(labels)) {
    return index
  }
  const tmp = labels[index]
  const tmpArray = tmp?.split(/[\s\/]+/)
  // if (tmpArray.length > 8) {
  //   const newArray = [...tmpArray].slice(0, 8)
  //   newArray.push('...')
  //   return newArray
  // }
  return tmpArray ?? 'NULL'
}

export const pieOption = (showLegend, sign) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        font: (context) => fontChange(context),
        color: '#FFF',
        formatter: (val) => {
          return val + sign
        },
      },
    },
    legend: {
      display: showLegend,
      labels: {
        font: (context) => fontChange(context),
        usePointStyle: true,
        pointStyle: 'rect',
      },
    },
  }
}

export const hundredPercentStackedBarOption = (
  showLegend,
  sign,
  value = null
) => {
  const _option: any = {
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    plugins: {
      datalabels: {
        align: 'center' as const,
        anchor: 'center' as const,
        font: (context) => fontChange(context),
        formatter: (val) => {
          return val + sign
        },
      },
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      y: {
        stacked: true,
        ticks: {
          font: (context) => fontChange(context),
        },
      },
      x: {
        stacked: true,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }

  if (!isEmpty(value)) {
    return {
      ..._option,
      plugins: {
        ..._option.plugins,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              xMin: value,
              xMax: value,
              borderColor: '#ADADAD',
              borderWidth: 3,
              borderDash: [4],
            },
          },
        },
      },
    }
  } else {
    const tmpValue = {
      ..._option,
      plugins: {
        ..._option.plugins,
      },
    }
    delete tmpValue.plugins.annotation
    return tmpValue
  }
}

export const hundredPercentStackedBarGlassonsOption = (
  showLegend,
  sign,
  value = null
) => {
  const _option: any = {
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    interaction: {
      intersect: true,
      mode: 'index',
    },
    plugins: {
      datalabels: {
        align: 'end' as const,
        anchor: 'end' as const,
        font: (context) => fontChange(context),
        labels: {
          value: {
            color: '3d3d3d',
          },
        },
        formatter: function (value, ctx) {
          // return value
          const datasetIndex = ctx.datasetIndex
          const dataIndex = ctx.dataIndex

          // Check if it's the second dataset
          if (datasetIndex === 1) {
            // Access the value from the first dataset
            const firstDatasetValue = ctx.chart.data.datasets[0].data[dataIndex]
            // Sum the values from both datasets
            const summedValue = value + firstDatasetValue
            // const total = summedValue + firstDatasetValue

            let percentage = (firstDatasetValue / summedValue) * 100

            return `${percentage.toFixed(2)}%`
          }

          // For all other cases, don't display anything
          return ''
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const data = tooltipItem.chart.data
            const datasetIndex = tooltipItem.datasetIndex
            const dataIndex = tooltipItem.dataIndex

            let label = tooltipItem.dataset.label || '' // Get the native label

            // If this is the second dataset (index 1), calculate the sum of values from both datasets
            if (datasetIndex === 1) {
              const inspectedOrders = data.datasets[0].data[dataIndex]
              const assignedOrders = data.datasets[1].data[dataIndex]

              const totalOrders = inspectedOrders + assignedOrders

              label += `: ${totalOrders}`
              // label += `\n% of Inspected Orders:`
            } else {
              label += `: ${tooltipItem.raw}`
            }

            return label
          },
          footer: function (tooltipItems) {
            const data = tooltipItems[0].chart.data
            const dataIndex = tooltipItems[0].dataIndex

            // Get the value from the first dataset (Inspected Orders)
            const inspectedOrders = data.datasets[0].data[dataIndex]

            // Get the value from the second dataset (Assigned Orders)
            const assignedOrders = data.datasets[1].data[dataIndex]

            // Calculate the total by summing the values from both datasets
            const total = inspectedOrders + assignedOrders

            // Calculate the percentage of Inspected Orders relative to the total
            const percentage = ((inspectedOrders / total) * 100).toFixed(2)

            // Return a string with the inspected orders, percentage, and total
            return `% of Inspected Orders: ${percentage}%`
          },
        },
      },

      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
      },
    },
  }

  if (!isEmpty(value)) {
    return {
      ..._option,
      plugins: {
        ..._option.plugins,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              xMin: value,
              xMax: value,
              borderColor: '#ADADAD',
              borderWidth: 3,
              borderDash: [4],
            },
          },
        },
      },
    }
  } else {
    const tmpValue = {
      ..._option,
      plugins: {
        ..._option.plugins,
      },
    }
    delete tmpValue.plugins.annotation
    return tmpValue
  }
}

export const hundredPercentStackedColumnOption = (
  showLegend: boolean,
  sign: string
) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        font: (context) => fontChange(context),
        padding: {
          top: -10,
        },
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          font: (context) => fontChange(context),
        },
      },
      y: {
        stacked: true,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }
}

export const columnAndLineOption = (showLegend: boolean, sign: string) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        align: 'end' as const,
        anchor: 'end' as const,
        font: (context) => fontChange(context),
        padding: {
          top: -10,
        },
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
        },
      },
      y: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }
}

export const barOption = (showLegend, sign, labels) => {
  return {
    maintainAspectRatio: false,
    indexAxis: 'y' as const,
    plugins: {
      datalabels: {
        align: 'end' as const,
        anchor: 'end' as const,
        font: (context) => fontChange(context),
        color: 'rgba(255, 255, 255)',
        offset: 12,
        padding: {
          right: -10,
        },
        formatter: (val) => {
          return val + sign
        },
      },
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 50, bottom: 10 },
    },
    scales: {
      y: {
        stacked: false,
        padding: { right: 20 },
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value, index) {
            return getLabels(labels, index)
          },
        },
      },
      x: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }
}

export const columnOption = (showLegend, sign, labels) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        align: 'top' as const,
        anchor: 'end' as const,
        font: (context) => fontChange(context),
        padding: {
          top: -10,
        },

        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          autoSkip: false,
          font: (context) => fontChange(context),
          callback: function (value, index) {
            return getLabelsMultiArray(labels, index)
          },
        },
      },
      y: {
        stacked: false,
        ticks: {
          beginAtZero: true,
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }
}

export const lineOption = (showLegend, sign, value = null, labels) => {
  const _option: any = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        color: 'rgba(255, 255, 255)',
        align: 'top' as const,
        anchor: 'end' as const,
        font: (context) => fontChange(context),
        padding: {
          top: -10,
        },
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          autoSkip: false,
          font: (context) => fontChange(context),
          beginAtZero: true,
          callback: function (value, index) {
            return getLabelsMultiArray(labels, index)
          },
        },
      },
      y: {
        stacked: false,
        beginAtZero: true,
        suggestedMin: 0,
        suggestedMax: 10,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }

  if (!isEmpty(value)) {
    return {
      ..._option,
      plugins: {
        ..._option.plugins,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              yMin: value,
              yMax: value,
              borderColor: '#ADADAD',
              borderWidth: 3,
              borderDash: [4],
            },
          },
        },
      },
    }
  } else {
    const tmpValue = {
      ..._option,
      plugins: {
        ..._option.plugins,
      },
    }
    delete tmpValue.plugins.annotation
    return tmpValue
  }
}

export const areaOption = (showLegend, sign, value = null, labels) => {
  const _option: any = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        align: 'top' as const,
        anchor: 'end' as const,
        padding: {
          top: -10,
        },
        font: (context) => fontChange(context),
        formatter: (value) => {
          return Number.isInteger(value)
            ? value + sign
            : value.toFixed(2) + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
          autoSkip: false,
          beginAtZero: true,
          callback: function (value, index) {
            return getLabelsMultiArray(labels, index)
          },
        },
      },
      y: {
        stacked: false,
        beginAtZero: true,
        suggestedMin: 0,
        suggestedMax: 10,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }

  if (!isEmpty(value)) {
    return {
      ..._option,
      plugins: {
        ..._option.plugins,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              yMin: value,
              yMax: value,
              borderColor: '#ADADAD',
              borderWidth: 3,
              borderDash: [4],
            },
          },
        },
      },
    }
  } else {
    const tmpValue = {
      ..._option,
      plugins: {
        ..._option.plugins,
      },
    }
    delete tmpValue.plugins.annotation
    return tmpValue
  }
}

export const guageOption = (showLegend, sign, target = null) => {
  const _option = {
    maintainAspectRatio: false,
    rotation: 270, // start angle in degrees
    circumference: 180, // sweep angle in degrees
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        font: (context) => fontChange(context),
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: {
        left: 100,
        right: 100,
      },
    },
    cutout: 120,
    ...target,
  }

  if (!isEmpty(target)) {
    return {
      ..._option,
      plugins: {
        ..._option.plugins,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              yMin: target,
              yMax: target,
              borderColor: '#ADADAD',
              borderWidth: 3,
              borderDash: [4],
            },
          },
        },
      },
    }
  } else {
    const tmpValue = {
      ..._option,
      plugins: {
        ..._option.plugins,
      },
    }
    delete tmpValue.plugins.annotation
    return tmpValue
  }
}

export const doughnutOption = (showLegend, sign) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        font: (context) => fontChange(context),
        formatter: (val) => {
          return val + sign
        },
      },
    },
  }
}

export const twoColumnOption = (showLegend, sign) => {
  return {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
        display: showLegend,
        labels: {
          font: (context) => fontChange(context),
          usePointStyle: true,
          pointStyle: 'rectRounded',
        },
      },
      datalabels: {
        display: true,
        font: (context) => fontChange(context),
        formatter: (val) => {
          return val + sign
        },
      },
    },
    layout: {
      padding: { top: 10, left: 20, right: 20, bottom: 10 },
    },
    scales: {
      x: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
        },
      },
      y: {
        stacked: false,
        ticks: {
          font: (context) => fontChange(context),
          callback: function (value) {
            return value + sign
          },
        },
      },
    },
  }
}
